import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'stay-mgmt-do-not-cancel-button',
  templateUrl: './do-not-cancel-button.component.html',
  styleUrls: ['./do-not-cancel-button.component.scss']
})
export class DoNotCancelButtonComponent implements OnInit {

  @Input() messages;
  @Output() doNotCancelButtonClicked: EventEmitter<string>;

  do_not_cancel: string;
  constructor() {
    this.doNotCancelButtonClicked = new EventEmitter();
  }

  ngOnInit() {
  }

  onButtonClick(): void {
    this.doNotCancelButtonClicked.emit();
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/do-not-cancel-button/do-not-cancel-button.component.ts